import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import View from './view';
import FirstPersonViewport from '../viewports/first-person-viewport';
import FirstPersonController from '../controllers/first-person-controller';
export default class FirstPersonView extends View {
  get ViewportType() {
    return FirstPersonViewport;
  }

  get ControllerType() {
    return FirstPersonController;
  }

}

_defineProperty(FirstPersonView, "displayName", 'FirstPersonView');
//# sourceMappingURL=first-person-view.js.map